import { render, staticRenderFns } from "./BookingRatesOwnerPriceForm.vue?vue&type=template&id=07cebc4a&"
import script from "./BookingRatesOwnerPriceForm.vue?vue&type=script&lang=js&"
export * from "./BookingRatesOwnerPriceForm.vue?vue&type=script&lang=js&"
import style0 from "./BookingRatesOwnerPriceForm.vue?vue&type=style&index=0&id=07cebc4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports